import { bzAxios } from 'Lib/bzAxios'
import { BzDomain } from 'Types/TagsResponse'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const setBzMonitorMode = (
  tagId: number,
  isMonitorOnly: boolean
): Promise<BzDomain | Error> => {
  return bzAxios
    .post<BzDomain>('/tags/monitoring', { searchId: tagId, isMonitoring: isMonitorOnly })
    .then((res) => {
      return res.data
    })
    .catch((e: Error) => {
      return e
    })
}

export const useSetBzMonitorMode = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['setBzMonitorMode'],
    mutationFn: ({ tagId, isBzMonitor }: { tagId: number; isBzMonitor: boolean }) =>
      setBzMonitorMode(tagId, isBzMonitor),
    onSettled: () => {
      void queryClient.invalidateQueries(['tagsListPerNetworkId'])
    },
  })
}
